export class ValidationError extends Error {}
export class ApplicationError extends Error {
    constructor(protected code: string, public message: string, private data: any) {
        super();
        this.code;
        this.message;
        this.data;
    }
}
export class SystemError extends Error {}
export class NoResponseError extends Error {}
export class InternalError extends Error {}
export class AccessDeniedError extends Error {}
export class UnauthorizedError extends Error {}
